/**
 * The base URL a participant's own systems call, per corridor.
 *
 * Participants reach the HTTP APIs through the same address as this portal:
 * the edge serves the FSPIOP engine at /api and the ISO 20022 engine at
 * /iso20022/api. Request paths in the certification packs start with /api, so
 * the base is the portal's address, plus /iso20022 for ISO 20022. (The card
 * link is not HTTP and has its own endpoint: see cardEndpoint.)
 */
export function participantApiBase(corridor, origin = window.location.origin) {
  const base = String(origin).replace(/\/+$/, '');
  return corridor === 'ISO20022' ? `${base}/iso20022` : base;
}
